import {
  ModalContainer,
  useMatchBreakpoints,
  CloseIcon,
  IconButton,
  Text,
  Flex,
  Box,
  ModalTitle,
  Button,
  useModal,
} from '@noahswap/uikit'
import { useTranslation } from '@noahswap/localization'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useDebounce from 'hooks/useDebounce'
import styled from 'styled-components'
import { AutoColumn, ColumnCenter } from 'components/Layout/Column'
import { useState, useCallback, useEffect } from 'react'
import NumericalInput from 'components/CurrencyInputPanel/NumericalInput'
import ResultModal from 'components/ResultModal'
import { useGasPrice } from 'state/user/hooks'
import { useTransactionAdder } from 'state/transactions/hooks'
import { useVesterContract } from 'hooks/useContract'
import BonusHelper from 'components/BonusHelper'
import { parseUnits } from '@ethersproject/units'
import { transactionErrorToUserReadableMessage } from 'utils/transactionErrorToUserReadableMessage'
import { getBalanceAmount, formatBigNumberToFixed, formatFixedNumber, getRes } from 'utils/formatBalance'
import Tabs from './Tabs'

export const ModalHeader = styled.div<{ background?: string }>`
  align-items: center;
  background: transparent;
  display: flex;
  padding: 12px 24px;
`

export const ModalBody = styled(Flex)`
  /* align-items: center; */
  background: transparent;
  display: flex;
  padding: 0 30px 30px;
  /* justify-content: center; */
  flex-direction: column;
`
const Wrapper = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 420px !important;
  padding-bottom: 100px;
`
const LabelRow = styled.div<{ width?: string }>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.75rem;
  line-height: 1rem;
  padding: 10px 1rem 10px 0;
  width: ${({ width }) => width || '100%'};
`
const LockModal: React.FC<React.PropsWithChildren<any>> = ({ onDismiss, allData = {}, handleSubmit }) => {
  const { isMobile } = useMatchBreakpoints()
  const gasPrice = useGasPrice()
  const { t } = useTranslation()
  const { chainId } = useActiveWeb3React()
  const [type, setType] = useState<number>(0)
  const [numInput, setNumInput] = useState<any>()
  const debounceNumInput = useDebounce(numInput, 200)
  const tabList = [
    // 增加质押
    {
      id: 1,
      label: t('noah326'),
      value: 0,
    },
    // 减少质押
    {
      id: 2,
      label: t('noah327'),
      value: 1,
    },
  ]
  const onUserInput = useCallback((value: string) => {
    onUserInput(value)
  }, [])
  const buttonText = (): any => {
    if (!type && Number(debounceNumInput) > Number(allData.balanceEsNoah)) {
      return t('Insufficient %coin% balance', {
        coin: 'esNOAH',
      })
    }
    if (type && Number(debounceNumInput) > Number(allData.lockEsNoah)) {
      return t('Insufficient %coin% balance', {
        coin: 'esNOAH',
      })
    }
    // 确定
    if (Number(debounceNumInput) > 0) {
      return t('noah78')
    }
    return t('noah303')
  }

  const handleSubmit1 = () => {
    handleSubmit(type, debounceNumInput)
  }
  useEffect(() => {
    setNumInput('')
  }, [type])

  return (
    <ModalContainer $minWidth={isMobile ? '100%' : '418px'} $minHeight={!isMobile ? '300px' : 'auto'}>
      <Box style={{ width: isMobile ? '100% ' : '418px' }}>
        <ModalHeader>
          {/* 解锁esNOAH */}
          <ModalTitle style={{ fontSize: '20px', fontWeight: '500' }}>{t('noah321')}</ModalTitle>
          <IconButton variant="text" onClick={onDismiss}>
            <CloseIcon width="24px" color="#000" />
          </IconButton>
        </ModalHeader>
        <ModalBody>
          <Tabs type={type} setType={setType} tabList={tabList} />
          {!type && (
            <Box>
              <Flex justifyContent="space-between" mb="10px" mt="20px">
                {/* 解锁上限 */}
                <Text fontSize="14px">{t('noah328')}</Text>
                {/* esNOAH */}
                <Text fontSize="14px">{getRes(allData?.lockedData, 4) || '0.0000'} esNOAH</Text>
              </Flex>
              <Flex justifyContent="space-between">
                {/* <Text fontSize="14px">解锁周期</Text> */}
                <Flex justifyContent="center" alignItems="center">
                  {/* 解锁周期 */}
                  <Text color="#14162A" mr="10px" small>
                    {t('noah314')}
                  </Text>
                  {/* <BonusHelper
                    placement="top-start"
                    ml="0"
                    text={
                      <Box>
                        <Text mb="3px">{t('noah395')}</Text>
                        <Text mb="3px">{t('noah396')}</Text>
                        <Text mb="3px">{t('noah397')}</Text>
                        <Text mb="3px">{t('noah398')}</Text>
                        <Text mb="3px">{t('noah399')}</Text>
                      </Box>
                    }
                  /> */}
                </Flex>
                {/* 365天/停止解锁/未解锁 */}
                {/* {Number(allData.lockEsNoah) === 0 ? (
                  // 未解锁
                  <Text small>{t('noah317')}</Text>
                ) : Number(allData.lockEsNoah) > 0 && Number(allData?.lockedData) === 0 ? (
                  // 停止解锁
                  <Text small>{t('noah316')}</Text>
                ) : (
                  // 解锁中
                  <Text small>
                    {getRes(allData.lockTimeEsNoah, 1) || '0.0'}&nbsp;
                    {t('noah275')}
                  </Text>
                )} */}
                <Text small>
                  {getRes(allData.lockTimeEsNoah, 1) || '0.0'}&nbsp;
                  {t('noah275')}
                </Text>
              </Flex>
            </Box>
          )}
          <Box background=" #FAFAFA;" borderRadius="6px" p="15px" mt="15px">
            <Flex justifyContent="space-between" style={{ cursor: 'pointer' }}>
              {/* 增加数量/减少数量 */}
              <Text fontSize="14px">{!type ? t('noah329') : t('noah336')}</Text>
              {/* 可增加数量/可减少数量 */}
              <Text
                fontSize="14px"
                color="#85868A"
                onClick={() => {
                  if (!type) {
                    setNumInput(allData.balanceEsNoah)
                  } else {
                    setNumInput(allData.lockEsNoah)
                  }
                }}
              >
                {!type ? t('noah330') : t('noah337')}:{' '}
                {!type
                  ? getRes(allData.balanceEsNoah || '0.0000', 4) || '0.0000'
                  : getRes(allData.lockEsNoah, 4) || '0.0000'}
              </Text>
            </Flex>
            <Flex>
              <LabelRow>
                <NumericalInput
                  align="left"
                  fontSize="20px"
                  placeholder={t('0.0')}
                  value={numInput}
                  onUserInput={(val: any) => {
                    const val1 = val
                    // if (!type && val1 > Number(allData.balanceEsNoah)) {
                    //   val1 = Number(allData.balanceEsNoah)
                    // }
                    // if (type && val1 > Number(allData.lockEsNoah)) {
                    //   val1 = Number(allData.lockEsNoah)
                    // }
                    setNumInput(val1)
                  }}
                />
              </LabelRow>
              <LabelRow width="25%" style={{ flexDirection: 'row-reverse', paddingRight: 0 }}>
                <Text color="#000" fontSize="14px">
                  esNOAH
                </Text>
              </LabelRow>
            </Flex>
          </Box>
          <Flex justifyContent="space-between" my="20px">
            {/* 解锁数量 */}
            <Text fontSize="14px">{t('noah313')}</Text>
            <Flex>
              <Text mr="10px" fontSize="14px">
                {getRes(allData?.lockEsNoah || '0.0000', 4) || '0.0000'}
              </Text>
              {Number(numInput) ? (
                <Flex alignItems="center">
                  <img
                    src="/images/small-img/to.png"
                    style={{ width: '14px', height: '10px' }}
                    alt=""
                    className="icon-cls"
                  />
                  <Text fontSize="14px" ml="10px">
                    {!type
                      ? Number(allData.lockEsNoah) + Number(numInput)
                      : Number(allData.lockEsNoah) - Number(numInput)}
                  </Text>
                </Flex>
              ) : (
                <></>
              )}
            </Flex>
          </Flex>
          {/* 请输入数量 / 确定 */}
          <Button
            width="100%"
            mb="20px"
            disabled={
              !Number(debounceNumInput) ||
              (!type && Number(debounceNumInput) > Number(allData.balanceEsNoah)) ||
              (type && Number(debounceNumInput) > Number(allData.lockEsNoah))
            }
            onClick={() => {
              handleSubmit1()
            }}
          >
            {buttonText()}
          </Button>
          {!type ? (
            <Box style={{ maxHeight: '150px', overflowY: 'scroll', margin: '0 -4px', padding: '0 4px 20px' }}>
              <Text fontSize="14px">· {t('noah332')}</Text>
              <Text fontSize="12px" pl="12px" color="#85868A" mb="10px">
                {t('noah333')}
              </Text>
              <Text fontSize="14px">· {t('noah334')}</Text>
              <Text fontSize="12px" pl="12px" color="#85868A" mb="10px">
                {t('noah335')}
              </Text>
              <Text fontSize="14px">· {t('noah448')}</Text>
              <Text fontSize="12px" pl="12px" color="#85868A" mb="30px">
                {t('noah449')}
              </Text>
            </Box>
          ) : (
            <Box>
              <Text fontSize="14px">· {t('noah440')}</Text>
              <Text fontSize="12px" pl="12px" color="#85868A" mb="10px">
                {t('noah441')}
              </Text>
            </Box>
          )}
        </ModalBody>
      </Box>
    </ModalContainer>
  )
}

export default LockModal
